/** System API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {SystemNs} from '@shared/types/system.namespace'

const api = createApi('system')

export const SystemApi = {
  getAllTimeZones: () =>
    api.post<void, SystemNs.TimeZone[]>('get-all-timezones'),
  helloSocket: () =>
    api.get<unknown>('hello-socket'),
  getOnlineUser: (workspaceId: string) =>
    api.get<string[]>(`online-users/${workspaceId}`),
}
